<template>
<div class="cfd-tr">
    <template v-for="column in columnsToShow">
        <div :class="['cfd-td', { 'cfd-align-right': isRightAligned(column) }]" v-if="!column.SubColumns || !column.SubColumns.length"
            :key="column.MatchingFieldName" v-html="instrument[column.MatchingFieldName].Text"></div>
        <template v-else>
            <div :class="['cfd-td', { 'cfd-align-right': isRightAligned(subcolumn) }]" v-for="subcolumn in column.SubColumns"
                :key="subcolumn.MatchingFieldName" v-html="instrument[subcolumn.MatchingFieldName].Text"></div>
        </template>
    </template>
</div>
</template>

<script>
export default {
    name: 'InstrumentTableRow',

    props: {
        instrument: {
            type: Object,
            required: true
        }
    },

    computed: {
        columnsToShow () {
            return this.$store.state.columnsToShow;
        }
    },

    methods: {
        isRightAligned (column) {
            return column.TextAlignment === 'right';
        }
    }
};
</script>

<style scoped>
.cfd-tr {
    display: table-row;
}

.cfd-tr:hover .cfd-td {
    background-color: #eeeeee;
}

.cfd-td {
    display: table-cell;
    vertical-align: top;
    padding: 14px 32px;
    font-size: 13px;
    line-height: 20px;
    white-space: pre;
    box-shadow: inset 0 -1px 0 0 #e0e0e0;
}

.cfd-td:first-child {
    position: sticky;
    left: 0;
    box-shadow: inset 0 -1px 0 0 #e0e0e0, inset -1px 0 0 0 #e0e0e0;
    background-color: #ffffff;
}

.cfd-tr:hover .cfd-td:first-child {
    background-color: #eeeeee;
}

.cfd-align-right {
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/desktop/InstrumentTableRow.vue